import fromPairs from 'lodash/fromPairs';

const IMGDROP_URL = 'https://imgdrop.imgix.net';
// implementation of imgix-url filter for non-angular environment
function imgixUrl(imgixFileAndParams: string): string {
  const [imgixFilename, imgixParamsString] = imgixFileAndParams.split('?');

  let imgixParams = {};
  if (imgixParamsString) {
    imgixParams = fromPairs(imgixParamsString.split('&').map((param) => param.split('=')));
  }

  const defaultImgixParams = {
    auto: 'format,compress', // reduce size, increase page speed, use most efficient image format
    ch: 'Width,DPR', // client hinting, where available
    dpr: '2', // 2x display for retina screens by default,
    fit: 'max', // use the `w` and `h` params as maximums
  };

  const defaultsAndParams = { ...defaultImgixParams, ...imgixParams };
  const params = Object.keys(defaultsAndParams)
    .map((key) => `${key}=${defaultsAndParams[key as keyof typeof defaultsAndParams]}`)
    .sort()
    .join('&');
  return `${IMGDROP_URL}/${imgixFilename}?${params}`;
}

export default imgixUrl;

import { ImageLoaderProps } from 'next/image';

// a custom imgixLoader, to handle url generation for next/images.
// their default imgix loader doesn't apply auto=compress or client hints :(
export function imgixLoader({ src, width, quality }: ImageLoaderProps): string {
  const [imgixFilename, imgixParamsString] = src.split('?');

  let imgixParams = {};
  if (imgixParamsString) {
    imgixParams = fromPairs(imgixParamsString.split('&').map((param) => param.split('=')));
  }

  const defaultImgixParams = {
    auto: 'format,compress', // reduce size, increase page speed, use most efficient image format
    ch: 'Width,DPR,Save-Data', // client hinting, where available
    fit: 'max', // use the `w` and `h` params as maximums (i.e. don't stretch the image)
    w: width,
    q: quality || '50', //no visible difference between 50% and 100% quality
  };

  const defaultsAndParams = { ...defaultImgixParams, ...imgixParams };
  const params = Object.keys(defaultsAndParams)
    .map((key) => `${key}=${defaultsAndParams[key as keyof typeof defaultsAndParams]}`)
    .sort()
    .join('&');
  return `${IMGDROP_URL}/${imgixFilename}?${params}`;
}
